import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/lib/auth';
import { EtudiantLayout } from './EtudiantLayout';
import { EntrepriseLayout } from './EntrepriseLayout';
import { ResponsableLayout } from './ResponsableLayout';
import { AdminLayout } from './AdminLayout';

/**
 * Layout pour /compte/* — réutilise le layout du rôle de l'utilisateur courant
 * pour que la barre latérale de l'espace reste visible quand on bascule sur
 * "Mes données" ou "Sécurité". Chaque layout contient son propre <Outlet />,
 * donc react-router rend la page de compte à l'intérieur.
 */
export function CompteLayout() {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="container py-16 text-center text-passage-ink-soft" role="status">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;

  switch (user.role) {
    case 'student':
      return <EtudiantLayout />;
    case 'company':
      return <EntrepriseLayout />;
    case 'responsable':
      return <ResponsableLayout />;
    case 'super_admin':
      return <AdminLayout />;
  }
}
